import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentForm } from './components/PaymentForm/PaymentForm';
import { PaymentSaved } from './components/PaymentSaved/PaymentSaved';
import { PaymentLoading } from './Payment.loading';
import { isEditingSelector, isOpenSelector, setIsOpen } from './state';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { usePaymentQuery } from './api/usePaymentQuery';

export const Payment: React.FC = () => {
  const isEditing = useSelector(isEditingSelector);

  const { isFetching, isError, refetch, data } = usePaymentQuery();

  if (isFetching) {
    return <PaymentLoading />;
  }

  if (isError) {
    return (
      <Box p={48}>
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (!isEditing && data.currentPaymentOption !== null) {
    return <PaymentSaved />;
  }

  return <PaymentForm />;
};

export const PaymentModal = () => {
  const isOpen = useSelector(isOpenSelector);

  const dispatch = useDispatch();

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen onRequestClose={() => dispatch(setIsOpen(false))} centered={false}>
      <ModalHeader>Payment Setup</ModalHeader>

      <ModalCloseButton onClick={() => dispatch(setIsOpen(false))} />

      <Payment />
    </Modal>
  );
};
